namespace PaperTrail.Texts {

    declare namespace Db {

        namespace Administration {

            namespace Language {
                export const Id: string;
                export const LanguageId: string;
                export const LanguageName: string;
            }

            namespace Role {
                export const RoleId: string;
                export const RoleKey: string;
                export const RoleName: string;
            }

            namespace RolePermission {
                export const PermissionKey: string;
                export const RoleId: string;
                export const RolePermissionId: string;
                export const RoleRoleName: string;
            }

            namespace Translation {
                export const CustomText: string;
                export const EntityPlural: string;
                export const Key: string;
                export const OverrideConfirmation: string;
                export const SaveChangesButton: string;
                export const SourceLanguage: string;
                export const SourceText: string;
                export const TargetLanguage: string;
                export const TargetText: string;
            }

            namespace User {
                export const DisplayName: string;
                export const Email: string;
                export const ImpersonationToken: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const LastDirectoryUpdate: string;
                export const MobilePhoneNumber: string;
                export const MobilePhoneVerified: string;
                export const Password: string;
                export const PasswordConfirm: string;
                export const PasswordHash: string;
                export const PasswordSalt: string;
                export const Roles: string;
                export const Source: string;
                export const TwoFactorAuth: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const UserId: string;
                export const UserImage: string;
                export const Username: string;
            }

            namespace UserPermission {
                export const Granted: string;
                export const PermissionKey: string;
                export const User: string;
                export const UserId: string;
                export const UserPermissionId: string;
                export const Username: string;
            }

            namespace UserRole {
                export const RoleId: string;
                export const User: string;
                export const UserId: string;
                export const UserRoleId: string;
                export const Username: string;
            }
        }

        namespace NewsletterControl {

            namespace Advertisement {
                export const AdvertisementId: string;
                export const Content: string;
                export const ImageBytes: string;
                export const Subtitle: string;
                export const Title: string;
                export const Url: string;
            }

            namespace News {
                export const Content: string;
                export const ImageBytes: string;
                export const NewsId: string;
                export const Subtitle: string;
                export const Title: string;
                export const Url: string;
            }

            namespace NewsSection {
                export const Content: string;
                export const ImageBytes: string;
                export const NewsSectionId: string;
                export const NewsletterPageTemplateId: string;
                export const NewsletterPageTemplateNewsletterId: string;
                export const NewsletterPageTemplatePageTemplateId: string;
                export const Title: string;
            }

            namespace Newsletter {
                export const CreatedBy: string;
                export const CreatedByDisplayName: string;
                export const CreatedByEmail: string;
                export const CreatedByInsertDate: string;
                export const CreatedByInsertUserId: string;
                export const CreatedByIsActive: string;
                export const CreatedByLastDirectoryUpdate: string;
                export const CreatedByMobilePhoneNumber: string;
                export const CreatedByMobilePhoneVerified: string;
                export const CreatedBySource: string;
                export const CreatedByTwoFactorAuth: string;
                export const CreatedByUpdateDate: string;
                export const CreatedByUpdateUserId: string;
                export const CreatedByUserImage: string;
                export const CreatedByUsername: string;
                export const DateCreated: string;
                export const DateModified: string;
                export const DatePublish: string;
                export const ModifiedBy: string;
                export const ModifiedByDisplayName: string;
                export const ModifiedByUsername: string;
                export const NewsletterAdsList: string;
                export const NewsletterId: string;
                export const NewsletterName: string;
                export const NewsletterNewsList: string;
                export const PageCount: string;
                export const PageTemplates: string;
                export const Stories: string;
                export const StyleSheetBackgroundColor: string;
                export const StyleSheetColumns: string;
                export const StyleSheetFont: string;
                export const StyleSheetFontSize: string;
                export const StyleSheetForeColor: string;
                export const StyleSheetHeight: string;
                export const StyleSheetId: string;
                export const StyleSheetIsBold: string;
                export const StyleSheetIsItalic: string;
                export const StyleSheetIsUnderline: string;
                export const StyleSheetMargin: string;
                export const StyleSheetPadding: string;
                export const StyleSheetRotation: string;
                export const StyleSheetRows: string;
                export const StyleSheetTextAlignment: string;
                export const StyleSheetTitle: string;
                export const StyleSheetWidth: string;
                export const SubscriptionEditorUserId: string;
                export const SubscriptionFrequency: string;
                export const SubscriptionId: string;
                export const SubscriptionName: string;
                export const SubscriptionUsersList: string;
                export const UsersList: string;
            }

            namespace NewsletterAdvertisement {
                export const AdvertisementContent: string;
                export const AdvertisementId: string;
                export const AdvertisementImageBytes: string;
                export const AdvertisementSubtitle: string;
                export const AdvertisementTitle: string;
                export const AdvertisementUrl: string;
                export const NewsletterAdvertisementId: string;
                export const NewsletterCreatedBy: string;
                export const NewsletterDateCreated: string;
                export const NewsletterDateModified: string;
                export const NewsletterId: string;
                export const NewsletterModifiedBy: string;
                export const NewsletterNewsletterName: string;
                export const NewsletterPageCount: string;
                export const NewsletterStyleSheetId: string;
            }

            namespace NewsletterNews {
                export const NewsContent: string;
                export const NewsId: string;
                export const NewsImageBytes: string;
                export const NewsSubtitle: string;
                export const NewsTitle: string;
                export const NewsUrl: string;
                export const NewsletterCreatedBy: string;
                export const NewsletterDateCreated: string;
                export const NewsletterDateModified: string;
                export const NewsletterId: string;
                export const NewsletterModifiedBy: string;
                export const NewsletterNewsId: string;
                export const NewsletterNewsletterName: string;
                export const NewsletterPageCount: string;
                export const NewsletterStyleSheetId: string;
            }

            namespace NewsletterPageTemplate {
                export const IsFrontPage: string;
                export const NewsletterCreatedBy: string;
                export const NewsletterDateCreated: string;
                export const NewsletterDateModified: string;
                export const NewsletterId: string;
                export const NewsletterModifiedBy: string;
                export const NewsletterNewsletterName: string;
                export const NewsletterPageTemplateId: string;
                export const NewsletterPages: string;
                export const NewsletterStyleSheetId: string;
                export const PageTemplateAdsSpots: string;
                export const PageTemplateFileName: string;
                export const PageTemplateId: string;
                export const PageTemplateIsFilled: string;
                export const PageTemplateNewsSpots: string;
                export const PageTemplateRank: string;
                export const PageTemplateTitle: string;
                export const Rank: string;
                export const TemplateSections: string;
            }

            namespace NewsletterStory {
                export const NewsletterCreatedBy: string;
                export const NewsletterDateCreated: string;
                export const NewsletterDateModified: string;
                export const NewsletterId: string;
                export const NewsletterModifiedBy: string;
                export const NewsletterNewsletterName: string;
                export const NewsletterPages: string;
                export const NewsletterStoryId: string;
                export const NewsletterStyleSheetId: string;
                export const StoryAds: string;
                export const StoryBlocks: string;
                export const StoryCharacters: string;
                export const StoryColumns: string;
                export const StoryDateModified: string;
                export const StoryDatePublished: string;
                export const StoryDateSubmitted: string;
                export const StoryDoPageBreak: string;
                export const StoryHighlights: string;
                export const StoryId: string;
                export const StoryImages: string;
                export const StoryIsPlaced: string;
                export const StoryNews: string;
                export const StoryNewsletterId: string;
                export const StoryPage: string;
                export const StoryPageTemplateId: string;
                export const StoryPageTemplateSectionId: string;
                export const StoryPosition: string;
                export const StoryRank: string;
                export const StoryRows: string;
                export const StoryStyleSheetId: string;
                export const StorySubtitle: string;
                export const StoryTitle: string;
                export const StoryUserId: string;
                export const UserDisplayName: string;
            }

            namespace NewsletterUser {
                export const NewsletterCreatedBy: string;
                export const NewsletterDateCreated: string;
                export const NewsletterDateModified: string;
                export const NewsletterId: string;
                export const NewsletterModifiedBy: string;
                export const NewsletterNewsletterName: string;
                export const NewsletterPageCount: string;
                export const NewsletterStyleSheetId: string;
                export const NewsletterUserId: string;
                export const UserDisplayName: string;
                export const UserEmail: string;
                export const UserId: string;
                export const UserInsertDate: string;
                export const UserInsertUserId: string;
                export const UserIsActive: string;
                export const UserLastDirectoryUpdate: string;
                export const UserMobilePhoneNumber: string;
                export const UserMobilePhoneVerified: string;
                export const UserSource: string;
                export const UserTwoFactorAuth: string;
                export const UserUpdateDate: string;
                export const UserUpdateUserId: string;
                export const UserUserImage: string;
                export const UserUsername: string;
            }

            namespace PageTemplate {
                export const AdsSpots: string;
                export const FileName: string;
                export const IsFilled: string;
                export const IsFrontPage: string;
                export const NewsSpots: string;
                export const PageTemplateId: string;
                export const Rank: string;
                export const TemplateSections: string;
                export const Title: string;
            }

            namespace PageTemplateSection {
                export const CharactersLimit: string;
                export const Columns: string;
                export const DoPageBreak: string;
                export const Height: string;
                export const Identifier: string;
                export const IsFilled: string;
                export const PageTemplateAdsSpots: string;
                export const PageTemplateFileName: string;
                export const PageTemplateId: string;
                export const PageTemplateIsFilled: string;
                export const PageTemplateNewsSpots: string;
                export const PageTemplateRank: string;
                export const PageTemplateSectionId: string;
                export const PageTemplateTitle: string;
                export const Rank: string;
                export const Rows: string;
                export const StyleSheetBackgroundColor: string;
                export const StyleSheetColumns: string;
                export const StyleSheetFont: string;
                export const StyleSheetFontSize: string;
                export const StyleSheetForeColor: string;
                export const StyleSheetHeight: string;
                export const StyleSheetId: string;
                export const StyleSheetIsBold: string;
                export const StyleSheetIsItalic: string;
                export const StyleSheetIsUnderline: string;
                export const StyleSheetMargin: string;
                export const StyleSheetPadding: string;
                export const StyleSheetRotation: string;
                export const StyleSheetRows: string;
                export const StyleSheetTextAlignment: string;
                export const StyleSheetTitle: string;
                export const StyleSheetWidth: string;
                export const Width: string;
            }

            namespace Story {
                export const Characters: string;
                export const Columns: string;
                export const DateModified: string;
                export const DatePublished: string;
                export const DateSubmitted: string;
                export const DoPageBreak: string;
                export const ImageUpload: string;
                export const IsPlaced: string;
                export const NewsletterCreatedBy: string;
                export const NewsletterDateCreated: string;
                export const NewsletterDateModified: string;
                export const NewsletterId: string;
                export const NewsletterModifiedBy: string;
                export const NewsletterNewsletterName: string;
                export const NewsletterPages: string;
                export const NewsletterStyleSheetId: string;
                export const NewslettersList: string;
                export const Page: string;
                export const PageTemplateId: string;
                export const PageTemplateSectionId: string;
                export const Position: string;
                export const Rank: string;
                export const Rows: string;
                export const StoryAds: string;
                export const StoryBlocks: string;
                export const StoryHighlights: string;
                export const StoryId: string;
                export const StoryImages: string;
                export const StoryNews: string;
                export const StoryText: string;
                export const StyleSheetBackgroundColor: string;
                export const StyleSheetColumns: string;
                export const StyleSheetFont: string;
                export const StyleSheetFontSize: string;
                export const StyleSheetForeColor: string;
                export const StyleSheetHeight: string;
                export const StyleSheetId: string;
                export const StyleSheetIsBold: string;
                export const StyleSheetIsItalic: string;
                export const StyleSheetIsUnderline: string;
                export const StyleSheetMargin: string;
                export const StyleSheetPadding: string;
                export const StyleSheetRotation: string;
                export const StyleSheetRows: string;
                export const StyleSheetTextAlignment: string;
                export const StyleSheetTitle: string;
                export const StyleSheetWidth: string;
                export const Subtitle: string;
                export const Title: string;
                export const UserDisplayName: string;
                export const UserEmail: string;
                export const UserId: string;
                export const UserInsertDate: string;
                export const UserInsertUserId: string;
                export const UserIsActive: string;
                export const UserLastDirectoryUpdate: string;
                export const UserMobilePhoneNumber: string;
                export const UserMobilePhoneVerified: string;
                export const UserSource: string;
                export const UserTwoFactorAuth: string;
                export const UserUpdateDate: string;
                export const UserUpdateUserId: string;
                export const UserUserImage: string;
                export const UserUsername: string;
            }

            namespace StoryAdvertisement {
                export const AdvertisementContent: string;
                export const AdvertisementId: string;
                export const AdvertisementSubtitle: string;
                export const AdvertisementTitle: string;
                export const AdvertisementUrl: string;
                export const StoryAdvertisementId: string;
                export const StoryCharacters: string;
                export const StoryColumns: string;
                export const StoryDateModified: string;
                export const StoryDatePublished: string;
                export const StoryDateSubmitted: string;
                export const StoryDoPageBreak: string;
                export const StoryId: string;
                export const StoryIsPlaced: string;
                export const StoryNewsletterId: string;
                export const StoryPage: string;
                export const StoryPageTemplateId: string;
                export const StoryPageTemplateSectionId: string;
                export const StoryPosition: string;
                export const StoryRank: string;
                export const StoryRows: string;
                export const StoryStyleSheetId: string;
                export const StorySubtitle: string;
                export const StoryTitle: string;
                export const StoryUserId: string;
            }

            namespace StoryContributor {
                export const Characters: string;
                export const Columns: string;
                export const DateModified: string;
                export const DatePublished: string;
                export const DateSubmitted: string;
                export const DoPageBreak: string;
                export const IsPlaced: string;
                export const NewsletterCreatedBy: string;
                export const NewsletterDateCreated: string;
                export const NewsletterDateModified: string;
                export const NewsletterId: string;
                export const NewsletterModifiedBy: string;
                export const NewsletterNewsletterName: string;
                export const NewsletterPages: string;
                export const NewsletterStyleSheetId: string;
                export const NewslettersList: string;
                export const PageTemplateId: string;
                export const PageTemplateSectionId: string;
                export const Position: string;
                export const Rank: string;
                export const Rows: string;
                export const StoryAds: string;
                export const StoryBlocks: string;
                export const StoryHighlights: string;
                export const StoryId: string;
                export const StoryImages: string;
                export const StoryNews: string;
                export const StoryText: string;
                export const StyleSheetBackgroundColor: string;
                export const StyleSheetColumns: string;
                export const StyleSheetFont: string;
                export const StyleSheetFontSize: string;
                export const StyleSheetForeColor: string;
                export const StyleSheetHeight: string;
                export const StyleSheetId: string;
                export const StyleSheetIsBold: string;
                export const StyleSheetIsItalic: string;
                export const StyleSheetIsUnderline: string;
                export const StyleSheetMargin: string;
                export const StyleSheetPadding: string;
                export const StyleSheetRotation: string;
                export const StyleSheetRows: string;
                export const StyleSheetTextAlignment: string;
                export const StyleSheetTitle: string;
                export const StyleSheetWidth: string;
                export const Subtitle: string;
                export const Title: string;
                export const UserDisplayName: string;
                export const UserEmail: string;
                export const UserId: string;
                export const UserInsertDate: string;
                export const UserInsertUserId: string;
                export const UserIsActive: string;
                export const UserLastDirectoryUpdate: string;
                export const UserMobilePhoneNumber: string;
                export const UserMobilePhoneVerified: string;
                export const UserSource: string;
                export const UserTwoFactorAuth: string;
                export const UserUpdateDate: string;
                export const UserUpdateUserId: string;
                export const UserUserImage: string;
                export const UserUsername: string;
            }

            namespace StoryHighlight {
                export const StoryCharacters: string;
                export const StoryColumns: string;
                export const StoryDateModified: string;
                export const StoryDatePublished: string;
                export const StoryDateSubmitted: string;
                export const StoryDoPageBreak: string;
                export const StoryHighlightId: string;
                export const StoryId: string;
                export const StoryIsPlaced: string;
                export const StoryNewsletterId: string;
                export const StoryPage: string;
                export const StoryPageTemplateId: string;
                export const StoryPageTemplateSectionId: string;
                export const StoryPosition: string;
                export const StoryRank: string;
                export const StoryRows: string;
                export const StoryStyleSheetId: string;
                export const StorySubtitle: string;
                export const StoryTitle: string;
                export const StoryUserId: string;
                export const Text: string;
            }

            namespace StoryImage {
                export const Description: string;
                export const ImageBytes: string;
                export const ImageFileName: string;
                export const ImageUpload: string;
                export const StoryCharacters: string;
                export const StoryColumns: string;
                export const StoryDateModified: string;
                export const StoryDatePublished: string;
                export const StoryDateSubmitted: string;
                export const StoryDoPageBreak: string;
                export const StoryId: string;
                export const StoryImageId: string;
                export const StoryIsPlaced: string;
                export const StoryNewsletterId: string;
                export const StoryPage: string;
                export const StoryPageTemplateId: string;
                export const StoryPageTemplateSectionId: string;
                export const StoryPosition: string;
                export const StoryRank: string;
                export const StoryRows: string;
                export const StoryStyleSheetId: string;
                export const StorySubtitle: string;
                export const StoryTitle: string;
                export const StoryUserId: string;
                export const StyleSheetBackgroundColor: string;
                export const StyleSheetColumns: string;
                export const StyleSheetFont: string;
                export const StyleSheetFontSize: string;
                export const StyleSheetForeColor: string;
                export const StyleSheetHeight: string;
                export const StyleSheetId: string;
                export const StyleSheetIsBold: string;
                export const StyleSheetIsItalic: string;
                export const StyleSheetIsUnderline: string;
                export const StyleSheetMargin: string;
                export const StyleSheetPadding: string;
                export const StyleSheetRotation: string;
                export const StyleSheetRows: string;
                export const StyleSheetTextAlignment: string;
                export const StyleSheetTitle: string;
                export const StyleSheetWidth: string;
                export const Subtitle: string;
                export const Title: string;
            }

            namespace StoryNews {
                export const NewsContent: string;
                export const NewsId: string;
                export const NewsSubtitle: string;
                export const NewsTitle: string;
                export const NewsUrl: string;
                export const StoryCharacters: string;
                export const StoryColumns: string;
                export const StoryDateModified: string;
                export const StoryDatePublished: string;
                export const StoryDateSubmitted: string;
                export const StoryDoPageBreak: string;
                export const StoryId: string;
                export const StoryIsPlaced: string;
                export const StoryNewsId: string;
                export const StoryNewsletterId: string;
                export const StoryPage: string;
                export const StoryPageTemplateId: string;
                export const StoryPageTemplateSectionId: string;
                export const StoryPosition: string;
                export const StoryRank: string;
                export const StoryRows: string;
                export const StoryStyleSheetId: string;
                export const StorySubtitle: string;
                export const StoryTitle: string;
                export const StoryUserId: string;
            }

            namespace StoryTextBlock {
                export const Content: string;
                export const StoryCharacters: string;
                export const StoryColumns: string;
                export const StoryDateModified: string;
                export const StoryDatePublished: string;
                export const StoryDateSubmitted: string;
                export const StoryDoPageBreak: string;
                export const StoryId: string;
                export const StoryIsPlaced: string;
                export const StoryNewsletterId: string;
                export const StoryPage: string;
                export const StoryPageTemplateId: string;
                export const StoryPageTemplateSectionId: string;
                export const StoryPosition: string;
                export const StoryRank: string;
                export const StoryRows: string;
                export const StoryStyleSheetId: string;
                export const StorySubtitle: string;
                export const StoryTextBlockId: string;
                export const StoryTitle: string;
                export const StoryUserId: string;
                export const StyleSheetBackgroundColor: string;
                export const StyleSheetColumns: string;
                export const StyleSheetFont: string;
                export const StyleSheetFontSize: string;
                export const StyleSheetForeColor: string;
                export const StyleSheetHeight: string;
                export const StyleSheetId: string;
                export const StyleSheetIsBold: string;
                export const StyleSheetIsItalic: string;
                export const StyleSheetIsUnderline: string;
                export const StyleSheetMargin: string;
                export const StyleSheetPadding: string;
                export const StyleSheetRotation: string;
                export const StyleSheetRows: string;
                export const StyleSheetTextAlignment: string;
                export const StyleSheetTitle: string;
                export const StyleSheetWidth: string;
                export const Title: string;
            }

            namespace StyleSheet {
                export const BackgroundColor: string;
                export const Columns: string;
                export const Font: string;
                export const FontSize: string;
                export const ForeColor: string;
                export const Height: string;
                export const IsBold: string;
                export const IsItalic: string;
                export const IsUnderline: string;
                export const Margin: string;
                export const Padding: string;
                export const Rotation: string;
                export const Rows: string;
                export const StyleSheetId: string;
                export const TextAlignment: string;
                export const Title: string;
                export const Width: string;
            }

            namespace SubscriptionUser {
                export const SubscriptionCreatedBy: string;
                export const SubscriptionDateCreated: string;
                export const SubscriptionEditorUserId: string;
                export const SubscriptionFrequency: string;
                export const SubscriptionId: string;
                export const SubscriptionSubscriptionName: string;
                export const SubscriptionUserId: string;
                export const UserDisplayName: string;
                export const UserEmail: string;
                export const UserId: string;
                export const UserInsertDate: string;
                export const UserInsertUserId: string;
                export const UserIsActive: string;
                export const UserLastDirectoryUpdate: string;
                export const UserMobilePhoneNumber: string;
                export const UserMobilePhoneVerified: string;
                export const UserSource: string;
                export const UserTwoFactorAuth: string;
                export const UserUpdateDate: string;
                export const UserUpdateUserId: string;
                export const UserUserImage: string;
                export const UserUsername: string;
            }
        }

        namespace Subscription {

            namespace Subscription {
                export const CreatedBy: string;
                export const CreatedByDisplayName: string;
                export const CreatedByEmail: string;
                export const CreatedByInsertDate: string;
                export const CreatedByInsertUserId: string;
                export const CreatedByIsActive: string;
                export const CreatedByLastDirectoryUpdate: string;
                export const CreatedByMobilePhoneNumber: string;
                export const CreatedByMobilePhoneVerified: string;
                export const CreatedBySource: string;
                export const CreatedByTwoFactorAuth: string;
                export const CreatedByUpdateDate: string;
                export const CreatedByUpdateUserId: string;
                export const CreatedByUserImage: string;
                export const CreatedByUsername: string;
                export const DateCreated: string;
                export const EditorUserDisplayName: string;
                export const EditorUserEmail: string;
                export const EditorUserId: string;
                export const EditorUserInsertDate: string;
                export const EditorUserInsertUserId: string;
                export const EditorUserIsActive: string;
                export const EditorUserLastDirectoryUpdate: string;
                export const EditorUserMobilePhoneNumber: string;
                export const EditorUserMobilePhoneVerified: string;
                export const EditorUserSource: string;
                export const EditorUserTwoFactorAuth: string;
                export const EditorUserUpdateDate: string;
                export const EditorUserUpdateUserId: string;
                export const EditorUserUserImage: string;
                export const EditorUserUsername: string;
                export const Frequency: string;
                export const Newsletters: string;
                export const SubscriptionId: string;
                export const SubscriptionName: string;
                export const UsersList: string;
            }
        }
    }

    declare namespace Forms {

        namespace Membership {

            namespace ChangePassword {
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace ForgotPassword {
                export const BackToLogin: string;
                export const FormInfo: string;
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace Login {
                export const FacebookButton: string;
                export const ForgotPassword: string;
                export const GoogleButton: string;
                export const LoginToYourAccount: string;
                export const OR: string;
                export const RememberMe: string;
                export const SignInButton: string;
                export const SignUpButton: string;
            }

            namespace ResetPassword {
                export const BackToLogin: string;
                export const EmailSubject: string;
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace SignUp {
                export const AcceptTerms: string;
                export const ActivateEmailSubject: string;
                export const ActivationCompleteMessage: string;
                export const BackToLogin: string;
                export const ConfirmEmail: string;
                export const ConfirmPassword: string;
                export const DisplayName: string;
                export const Email: string;
                export const FormInfo: string;
                export const FormTitle: string;
                export const Password: string;
                export const SubmitButton: string;
                export const Success: string;
            }
        }
    }

    declare namespace Navigation {
        export const LogoutLink: string;
        export const SiteTitle: string;
    }

    declare namespace Site {

        namespace AccessDenied {
            export const ClickToChangeUser: string;
            export const ClickToLogin: string;
            export const LackPermissions: string;
            export const NotLoggedIn: string;
            export const PageTitle: string;
        }

        namespace BasicProgressDialog {
            export const CancelTitle: string;
            export const PleaseWait: string;
        }

        namespace BulkServiceAction {
            export const AllHadErrorsFormat: string;
            export const AllSuccessFormat: string;
            export const ConfirmationFormat: string;
            export const ErrorCount: string;
            export const NothingToProcess: string;
            export const SomeHadErrorsFormat: string;
            export const SuccessCount: string;
        }

        namespace Dashboard {
            export const ContentDescription: string;
        }

        namespace Dialogs {
            export const PendingChangesConfirmation: string;
        }

        namespace Layout {
            export const FooterCopyright: string;
            export const FooterInfo: string;
            export const FooterRights: string;
            export const GeneralSettings: string;
            export const Language: string;
            export const Theme: string;
            export const ThemeAzure: string;
            export const ThemeAzureLight: string;
            export const ThemeBlack: string;
            export const ThemeBlackLight: string;
            export const ThemeBlue: string;
            export const ThemeBlueLight: string;
            export const ThemeCosmos: string;
            export const ThemeCosmosLight: string;
            export const ThemeGlassy: string;
            export const ThemeGlassyLight: string;
            export const ThemeGreen: string;
            export const ThemeGreenLight: string;
            export const ThemePurple: string;
            export const ThemePurpleLight: string;
            export const ThemeRed: string;
            export const ThemeRedLight: string;
            export const ThemeYellow: string;
            export const ThemeYellowLight: string;
        }

        namespace RolePermissionDialog {
            export const DialogTitle: string;
            export const EditButton: string;
            export const SaveSuccess: string;
        }

        namespace UserDialog {
            export const EditPermissionsButton: string;
            export const EditRolesButton: string;
        }

        namespace UserPermissionDialog {
            export const DialogTitle: string;
            export const Grant: string;
            export const Permission: string;
            export const Revoke: string;
            export const SaveSuccess: string;
        }

        namespace UserRoleDialog {
            export const DialogTitle: string;
            export const SaveSuccess: string;
        }

        namespace ValidationError {
            export const Title: string;
        }
    }

    declare namespace Validation {
        export const AuthenticationError: string;
        export const CantFindUserWithEmail: string;
        export const CurrentPasswordMismatch: string;
        export const DeleteForeignKeyError: string;
        export const EmailConfirm: string;
        export const EmailInUse: string;
        export const InvalidActivateToken: string;
        export const InvalidResetToken: string;
        export const MinRequiredPasswordLength: string;
        export const SavePrimaryKeyError: string;
    }

    PaperTrail['Texts'] = Q.proxyTexts(Texts, '', {Db:{Administration:{Language:{Id:1,LanguageId:1,LanguageName:1},Role:{RoleId:1,RoleKey:1,RoleName:1},RolePermission:{PermissionKey:1,RoleId:1,RolePermissionId:1,RoleRoleName:1},Translation:{CustomText:1,EntityPlural:1,Key:1,OverrideConfirmation:1,SaveChangesButton:1,SourceLanguage:1,SourceText:1,TargetLanguage:1,TargetText:1},User:{DisplayName:1,Email:1,ImpersonationToken:1,InsertDate:1,InsertUserId:1,IsActive:1,LastDirectoryUpdate:1,MobilePhoneNumber:1,MobilePhoneVerified:1,Password:1,PasswordConfirm:1,PasswordHash:1,PasswordSalt:1,Roles:1,Source:1,TwoFactorAuth:1,UpdateDate:1,UpdateUserId:1,UserId:1,UserImage:1,Username:1},UserPermission:{Granted:1,PermissionKey:1,User:1,UserId:1,UserPermissionId:1,Username:1},UserRole:{RoleId:1,User:1,UserId:1,UserRoleId:1,Username:1}},NewsletterControl:{Advertisement:{AdvertisementId:1,Content:1,ImageBytes:1,Subtitle:1,Title:1,Url:1},News:{Content:1,ImageBytes:1,NewsId:1,Subtitle:1,Title:1,Url:1},NewsSection:{Content:1,ImageBytes:1,NewsSectionId:1,NewsletterPageTemplateId:1,NewsletterPageTemplateNewsletterId:1,NewsletterPageTemplatePageTemplateId:1,Title:1},Newsletter:{CreatedBy:1,CreatedByDisplayName:1,CreatedByEmail:1,CreatedByInsertDate:1,CreatedByInsertUserId:1,CreatedByIsActive:1,CreatedByLastDirectoryUpdate:1,CreatedByMobilePhoneNumber:1,CreatedByMobilePhoneVerified:1,CreatedBySource:1,CreatedByTwoFactorAuth:1,CreatedByUpdateDate:1,CreatedByUpdateUserId:1,CreatedByUserImage:1,CreatedByUsername:1,DateCreated:1,DateModified:1,DatePublish:1,ModifiedBy:1,ModifiedByDisplayName:1,ModifiedByUsername:1,NewsletterAdsList:1,NewsletterId:1,NewsletterName:1,NewsletterNewsList:1,PageCount:1,PageTemplates:1,Stories:1,StyleSheetBackgroundColor:1,StyleSheetColumns:1,StyleSheetFont:1,StyleSheetFontSize:1,StyleSheetForeColor:1,StyleSheetHeight:1,StyleSheetId:1,StyleSheetIsBold:1,StyleSheetIsItalic:1,StyleSheetIsUnderline:1,StyleSheetMargin:1,StyleSheetPadding:1,StyleSheetRotation:1,StyleSheetRows:1,StyleSheetTextAlignment:1,StyleSheetTitle:1,StyleSheetWidth:1,SubscriptionEditorUserId:1,SubscriptionFrequency:1,SubscriptionId:1,SubscriptionName:1,SubscriptionUsersList:1,UsersList:1},NewsletterAdvertisement:{AdvertisementContent:1,AdvertisementId:1,AdvertisementImageBytes:1,AdvertisementSubtitle:1,AdvertisementTitle:1,AdvertisementUrl:1,NewsletterAdvertisementId:1,NewsletterCreatedBy:1,NewsletterDateCreated:1,NewsletterDateModified:1,NewsletterId:1,NewsletterModifiedBy:1,NewsletterNewsletterName:1,NewsletterPageCount:1,NewsletterStyleSheetId:1},NewsletterNews:{NewsContent:1,NewsId:1,NewsImageBytes:1,NewsSubtitle:1,NewsTitle:1,NewsUrl:1,NewsletterCreatedBy:1,NewsletterDateCreated:1,NewsletterDateModified:1,NewsletterId:1,NewsletterModifiedBy:1,NewsletterNewsId:1,NewsletterNewsletterName:1,NewsletterPageCount:1,NewsletterStyleSheetId:1},NewsletterPageTemplate:{IsFrontPage:1,NewsletterCreatedBy:1,NewsletterDateCreated:1,NewsletterDateModified:1,NewsletterId:1,NewsletterModifiedBy:1,NewsletterNewsletterName:1,NewsletterPageTemplateId:1,NewsletterPages:1,NewsletterStyleSheetId:1,PageTemplateAdsSpots:1,PageTemplateFileName:1,PageTemplateId:1,PageTemplateIsFilled:1,PageTemplateNewsSpots:1,PageTemplateRank:1,PageTemplateTitle:1,Rank:1,TemplateSections:1},NewsletterStory:{NewsletterCreatedBy:1,NewsletterDateCreated:1,NewsletterDateModified:1,NewsletterId:1,NewsletterModifiedBy:1,NewsletterNewsletterName:1,NewsletterPages:1,NewsletterStoryId:1,NewsletterStyleSheetId:1,StoryAds:1,StoryBlocks:1,StoryCharacters:1,StoryColumns:1,StoryDateModified:1,StoryDatePublished:1,StoryDateSubmitted:1,StoryDoPageBreak:1,StoryHighlights:1,StoryId:1,StoryImages:1,StoryIsPlaced:1,StoryNews:1,StoryNewsletterId:1,StoryPage:1,StoryPageTemplateId:1,StoryPageTemplateSectionId:1,StoryPosition:1,StoryRank:1,StoryRows:1,StoryStyleSheetId:1,StorySubtitle:1,StoryTitle:1,StoryUserId:1,UserDisplayName:1},NewsletterUser:{NewsletterCreatedBy:1,NewsletterDateCreated:1,NewsletterDateModified:1,NewsletterId:1,NewsletterModifiedBy:1,NewsletterNewsletterName:1,NewsletterPageCount:1,NewsletterStyleSheetId:1,NewsletterUserId:1,UserDisplayName:1,UserEmail:1,UserId:1,UserInsertDate:1,UserInsertUserId:1,UserIsActive:1,UserLastDirectoryUpdate:1,UserMobilePhoneNumber:1,UserMobilePhoneVerified:1,UserSource:1,UserTwoFactorAuth:1,UserUpdateDate:1,UserUpdateUserId:1,UserUserImage:1,UserUsername:1},PageTemplate:{AdsSpots:1,FileName:1,IsFilled:1,IsFrontPage:1,NewsSpots:1,PageTemplateId:1,Rank:1,TemplateSections:1,Title:1},PageTemplateSection:{CharactersLimit:1,Columns:1,DoPageBreak:1,Height:1,Identifier:1,IsFilled:1,PageTemplateAdsSpots:1,PageTemplateFileName:1,PageTemplateId:1,PageTemplateIsFilled:1,PageTemplateNewsSpots:1,PageTemplateRank:1,PageTemplateSectionId:1,PageTemplateTitle:1,Rank:1,Rows:1,StyleSheetBackgroundColor:1,StyleSheetColumns:1,StyleSheetFont:1,StyleSheetFontSize:1,StyleSheetForeColor:1,StyleSheetHeight:1,StyleSheetId:1,StyleSheetIsBold:1,StyleSheetIsItalic:1,StyleSheetIsUnderline:1,StyleSheetMargin:1,StyleSheetPadding:1,StyleSheetRotation:1,StyleSheetRows:1,StyleSheetTextAlignment:1,StyleSheetTitle:1,StyleSheetWidth:1,Width:1},Story:{Characters:1,Columns:1,DateModified:1,DatePublished:1,DateSubmitted:1,DoPageBreak:1,ImageUpload:1,IsPlaced:1,NewsletterCreatedBy:1,NewsletterDateCreated:1,NewsletterDateModified:1,NewsletterId:1,NewsletterModifiedBy:1,NewsletterNewsletterName:1,NewsletterPages:1,NewsletterStyleSheetId:1,NewslettersList:1,Page:1,PageTemplateId:1,PageTemplateSectionId:1,Position:1,Rank:1,Rows:1,StoryAds:1,StoryBlocks:1,StoryHighlights:1,StoryId:1,StoryImages:1,StoryNews:1,StoryText:1,StyleSheetBackgroundColor:1,StyleSheetColumns:1,StyleSheetFont:1,StyleSheetFontSize:1,StyleSheetForeColor:1,StyleSheetHeight:1,StyleSheetId:1,StyleSheetIsBold:1,StyleSheetIsItalic:1,StyleSheetIsUnderline:1,StyleSheetMargin:1,StyleSheetPadding:1,StyleSheetRotation:1,StyleSheetRows:1,StyleSheetTextAlignment:1,StyleSheetTitle:1,StyleSheetWidth:1,Subtitle:1,Title:1,UserDisplayName:1,UserEmail:1,UserId:1,UserInsertDate:1,UserInsertUserId:1,UserIsActive:1,UserLastDirectoryUpdate:1,UserMobilePhoneNumber:1,UserMobilePhoneVerified:1,UserSource:1,UserTwoFactorAuth:1,UserUpdateDate:1,UserUpdateUserId:1,UserUserImage:1,UserUsername:1},StoryAdvertisement:{AdvertisementContent:1,AdvertisementId:1,AdvertisementSubtitle:1,AdvertisementTitle:1,AdvertisementUrl:1,StoryAdvertisementId:1,StoryCharacters:1,StoryColumns:1,StoryDateModified:1,StoryDatePublished:1,StoryDateSubmitted:1,StoryDoPageBreak:1,StoryId:1,StoryIsPlaced:1,StoryNewsletterId:1,StoryPage:1,StoryPageTemplateId:1,StoryPageTemplateSectionId:1,StoryPosition:1,StoryRank:1,StoryRows:1,StoryStyleSheetId:1,StorySubtitle:1,StoryTitle:1,StoryUserId:1},StoryContributor:{Characters:1,Columns:1,DateModified:1,DatePublished:1,DateSubmitted:1,DoPageBreak:1,IsPlaced:1,NewsletterCreatedBy:1,NewsletterDateCreated:1,NewsletterDateModified:1,NewsletterId:1,NewsletterModifiedBy:1,NewsletterNewsletterName:1,NewsletterPages:1,NewsletterStyleSheetId:1,NewslettersList:1,PageTemplateId:1,PageTemplateSectionId:1,Position:1,Rank:1,Rows:1,StoryAds:1,StoryBlocks:1,StoryHighlights:1,StoryId:1,StoryImages:1,StoryNews:1,StoryText:1,StyleSheetBackgroundColor:1,StyleSheetColumns:1,StyleSheetFont:1,StyleSheetFontSize:1,StyleSheetForeColor:1,StyleSheetHeight:1,StyleSheetId:1,StyleSheetIsBold:1,StyleSheetIsItalic:1,StyleSheetIsUnderline:1,StyleSheetMargin:1,StyleSheetPadding:1,StyleSheetRotation:1,StyleSheetRows:1,StyleSheetTextAlignment:1,StyleSheetTitle:1,StyleSheetWidth:1,Subtitle:1,Title:1,UserDisplayName:1,UserEmail:1,UserId:1,UserInsertDate:1,UserInsertUserId:1,UserIsActive:1,UserLastDirectoryUpdate:1,UserMobilePhoneNumber:1,UserMobilePhoneVerified:1,UserSource:1,UserTwoFactorAuth:1,UserUpdateDate:1,UserUpdateUserId:1,UserUserImage:1,UserUsername:1},StoryHighlight:{StoryCharacters:1,StoryColumns:1,StoryDateModified:1,StoryDatePublished:1,StoryDateSubmitted:1,StoryDoPageBreak:1,StoryHighlightId:1,StoryId:1,StoryIsPlaced:1,StoryNewsletterId:1,StoryPage:1,StoryPageTemplateId:1,StoryPageTemplateSectionId:1,StoryPosition:1,StoryRank:1,StoryRows:1,StoryStyleSheetId:1,StorySubtitle:1,StoryTitle:1,StoryUserId:1,Text:1},StoryImage:{Description:1,ImageBytes:1,ImageFileName:1,ImageUpload:1,StoryCharacters:1,StoryColumns:1,StoryDateModified:1,StoryDatePublished:1,StoryDateSubmitted:1,StoryDoPageBreak:1,StoryId:1,StoryImageId:1,StoryIsPlaced:1,StoryNewsletterId:1,StoryPage:1,StoryPageTemplateId:1,StoryPageTemplateSectionId:1,StoryPosition:1,StoryRank:1,StoryRows:1,StoryStyleSheetId:1,StorySubtitle:1,StoryTitle:1,StoryUserId:1,StyleSheetBackgroundColor:1,StyleSheetColumns:1,StyleSheetFont:1,StyleSheetFontSize:1,StyleSheetForeColor:1,StyleSheetHeight:1,StyleSheetId:1,StyleSheetIsBold:1,StyleSheetIsItalic:1,StyleSheetIsUnderline:1,StyleSheetMargin:1,StyleSheetPadding:1,StyleSheetRotation:1,StyleSheetRows:1,StyleSheetTextAlignment:1,StyleSheetTitle:1,StyleSheetWidth:1,Subtitle:1,Title:1},StoryNews:{NewsContent:1,NewsId:1,NewsSubtitle:1,NewsTitle:1,NewsUrl:1,StoryCharacters:1,StoryColumns:1,StoryDateModified:1,StoryDatePublished:1,StoryDateSubmitted:1,StoryDoPageBreak:1,StoryId:1,StoryIsPlaced:1,StoryNewsId:1,StoryNewsletterId:1,StoryPage:1,StoryPageTemplateId:1,StoryPageTemplateSectionId:1,StoryPosition:1,StoryRank:1,StoryRows:1,StoryStyleSheetId:1,StorySubtitle:1,StoryTitle:1,StoryUserId:1},StoryTextBlock:{Content:1,StoryCharacters:1,StoryColumns:1,StoryDateModified:1,StoryDatePublished:1,StoryDateSubmitted:1,StoryDoPageBreak:1,StoryId:1,StoryIsPlaced:1,StoryNewsletterId:1,StoryPage:1,StoryPageTemplateId:1,StoryPageTemplateSectionId:1,StoryPosition:1,StoryRank:1,StoryRows:1,StoryStyleSheetId:1,StorySubtitle:1,StoryTextBlockId:1,StoryTitle:1,StoryUserId:1,StyleSheetBackgroundColor:1,StyleSheetColumns:1,StyleSheetFont:1,StyleSheetFontSize:1,StyleSheetForeColor:1,StyleSheetHeight:1,StyleSheetId:1,StyleSheetIsBold:1,StyleSheetIsItalic:1,StyleSheetIsUnderline:1,StyleSheetMargin:1,StyleSheetPadding:1,StyleSheetRotation:1,StyleSheetRows:1,StyleSheetTextAlignment:1,StyleSheetTitle:1,StyleSheetWidth:1,Title:1},StyleSheet:{BackgroundColor:1,Columns:1,Font:1,FontSize:1,ForeColor:1,Height:1,IsBold:1,IsItalic:1,IsUnderline:1,Margin:1,Padding:1,Rotation:1,Rows:1,StyleSheetId:1,TextAlignment:1,Title:1,Width:1},SubscriptionUser:{SubscriptionCreatedBy:1,SubscriptionDateCreated:1,SubscriptionEditorUserId:1,SubscriptionFrequency:1,SubscriptionId:1,SubscriptionSubscriptionName:1,SubscriptionUserId:1,UserDisplayName:1,UserEmail:1,UserId:1,UserInsertDate:1,UserInsertUserId:1,UserIsActive:1,UserLastDirectoryUpdate:1,UserMobilePhoneNumber:1,UserMobilePhoneVerified:1,UserSource:1,UserTwoFactorAuth:1,UserUpdateDate:1,UserUpdateUserId:1,UserUserImage:1,UserUsername:1}},Subscription:{Subscription:{CreatedBy:1,CreatedByDisplayName:1,CreatedByEmail:1,CreatedByInsertDate:1,CreatedByInsertUserId:1,CreatedByIsActive:1,CreatedByLastDirectoryUpdate:1,CreatedByMobilePhoneNumber:1,CreatedByMobilePhoneVerified:1,CreatedBySource:1,CreatedByTwoFactorAuth:1,CreatedByUpdateDate:1,CreatedByUpdateUserId:1,CreatedByUserImage:1,CreatedByUsername:1,DateCreated:1,EditorUserDisplayName:1,EditorUserEmail:1,EditorUserId:1,EditorUserInsertDate:1,EditorUserInsertUserId:1,EditorUserIsActive:1,EditorUserLastDirectoryUpdate:1,EditorUserMobilePhoneNumber:1,EditorUserMobilePhoneVerified:1,EditorUserSource:1,EditorUserTwoFactorAuth:1,EditorUserUpdateDate:1,EditorUserUpdateUserId:1,EditorUserUserImage:1,EditorUserUsername:1,Frequency:1,Newsletters:1,SubscriptionId:1,SubscriptionName:1,UsersList:1}}},Forms:{Membership:{ChangePassword:{FormTitle:1,SubmitButton:1,Success:1},ForgotPassword:{BackToLogin:1,FormInfo:1,FormTitle:1,SubmitButton:1,Success:1},Login:{FacebookButton:1,ForgotPassword:1,GoogleButton:1,LoginToYourAccount:1,OR:1,RememberMe:1,SignInButton:1,SignUpButton:1},ResetPassword:{BackToLogin:1,EmailSubject:1,FormTitle:1,SubmitButton:1,Success:1},SignUp:{AcceptTerms:1,ActivateEmailSubject:1,ActivationCompleteMessage:1,BackToLogin:1,ConfirmEmail:1,ConfirmPassword:1,DisplayName:1,Email:1,FormInfo:1,FormTitle:1,Password:1,SubmitButton:1,Success:1}}},Navigation:{LogoutLink:1,SiteTitle:1},Site:{AccessDenied:{ClickToChangeUser:1,ClickToLogin:1,LackPermissions:1,NotLoggedIn:1,PageTitle:1},BasicProgressDialog:{CancelTitle:1,PleaseWait:1},BulkServiceAction:{AllHadErrorsFormat:1,AllSuccessFormat:1,ConfirmationFormat:1,ErrorCount:1,NothingToProcess:1,SomeHadErrorsFormat:1,SuccessCount:1},Dashboard:{ContentDescription:1},Dialogs:{PendingChangesConfirmation:1},Layout:{FooterCopyright:1,FooterInfo:1,FooterRights:1,GeneralSettings:1,Language:1,Theme:1,ThemeAzure:1,ThemeAzureLight:1,ThemeBlack:1,ThemeBlackLight:1,ThemeBlue:1,ThemeBlueLight:1,ThemeCosmos:1,ThemeCosmosLight:1,ThemeGlassy:1,ThemeGlassyLight:1,ThemeGreen:1,ThemeGreenLight:1,ThemePurple:1,ThemePurpleLight:1,ThemeRed:1,ThemeRedLight:1,ThemeYellow:1,ThemeYellowLight:1},RolePermissionDialog:{DialogTitle:1,EditButton:1,SaveSuccess:1},UserDialog:{EditPermissionsButton:1,EditRolesButton:1},UserPermissionDialog:{DialogTitle:1,Grant:1,Permission:1,Revoke:1,SaveSuccess:1},UserRoleDialog:{DialogTitle:1,SaveSuccess:1},ValidationError:{Title:1}},Validation:{AuthenticationError:1,CantFindUserWithEmail:1,CurrentPasswordMismatch:1,DeleteForeignKeyError:1,EmailConfirm:1,EmailInUse:1,InvalidActivateToken:1,InvalidResetToken:1,MinRequiredPasswordLength:1,SavePrimaryKeyError:1}});
}
